// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#login-pop{width:622px;height:605px;padding-top:55px}", ""]);
// Exports
module.exports = exports;
